<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">修改密码</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-labe" >
                <el-tabs>
                  <el-tab-pane label="修改手机号" class=" DeviceInfo">
                    <div class="root">
                        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                          <el-form-item label="原手机号" prop="tel">
                            <el-input placeholder="请输入原手机号" v-model.number="info.tel" disabled=""></el-input>
                          </el-form-item>

                          <el-form-item label="新手机号" prop="pass">
                            <el-input  placeholder="请设置新手机号" v-model="form.pass" autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item label="验证码" prop="验证码" class="code">
                              <el-input v-model="form.sendcode" placeholder="请输入验证码"></el-input>
                              <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false">发送验证码</el-button>
                              <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true">{{btntxt}}</el-button>
                          </el-form-item>
                          <el-form-item>
                            <el-button type="primary" @click="onSubmit(form)" size="medium">确定</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="h-30"></div>

              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>
<style scoped >
    .DeviceInfo{width: 45%;}
    .DeviceInfo >>> .el-tabs__item {font-size: 14px;}
    .DeviceInfo >>> .el-tabs__active-bar{width: 0 !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;;}
    .DeviceInfo >>> .el-tabs__nav-scroll{width: 84%;float: right;}
    .DeviceInfo >>> .el-button--medium{width: 100%;background: #2c5fab;border-color: #2c5fab;}

    .DeviceInfo >>> .root {width:100vw;display: table-cell;vertical-align: middle;}
    .DeviceInfo >>> .root  form {width: 100%;margin: auto;}
    .DeviceInfo >>> .root  form .code .el-input{width: 66%;border-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-button {background: #f5f7fa;width: 34%;border-top-left-radius: 0px;border-bottom-left-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-input .el-input__inner{border-top-right-radius: 0px;border-bottom-right-radius: 0px;}
</style>
<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'


export default{
  data(){
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号'));
        }
      };
    return {
      activeName: 'second',
      name: "Register",
      info:{},
      activeIndex: '3',
      form: {
          tel: '',
          pass:'',
          checkPass:'',
          name:'',
          dwzw:'',
          sendcode: '',
      },
      rules: {
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
        ],
        pass: [
          {  required: true,message: '请输入新手机号', trigger: 'blur' }
        ],
      },

      Register: {
          tel: '',
          sendcode: '',
          pass:'',
          checkPass:'',
      },
      disabled: false,
      time: 0,
      btntxt: "重新发送",
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,

  },
  mounted () {
    var that = this;
    var userid = that.$cookieStore.getCookie('userid');
    that.$api.post("/Member/Member",{'userid':userid}).then(res => {
      console.log(res);
      that.info= res.form;
    });
  },
  methods:{
    // 选项卡切换
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 登录提交
    onSubmit(form) {
      console.log(form);

      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if(form.pass=='' ){
         this.$message.error('请输入新手机号');
         return
      }
      if (!reg.test(this.form.pass)) {
          this.$message.error('请输入正确的手机号');
          return
      }

      var that = this;
      var yzms =  this.$cookieStore.getCookie('yzms');  // 获取返回来的验证码
      if(form.sendcode==''){
        this.$message.error('验证码不能为空');
        return
      }
      if(form.yzms==''){
        this.$message.error('验证码已过期');
        return
      }

      if(form.sendcode===yzms){
        console.log(yzms);
        that.$api.post("/Login/updatezh",{'tel':this.info.tel,'pass':form.pass}).then(res => {
            console.log(res);
            if(res.code==1){
              that.show = false;
              that.form.tel = form.pass;
              that.form.sendcode = '';
              that.form.pass = '';
              // this.$cookieStore.setCookie( 'userid' ,res.userid, 360000);
              // this.$cookieStore.delCookie('yzms');
              this.$message({
                message: res.msg,
                type: 'success'
              });
              // setTimeout(this.$router.push('/Login'), 1000);
            }
        })
      }else{
        this.$message.error('请输入正确验证码');
      }
    },


    //手机验证发送验证码
    sendcode() {
      var that = this;
        const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
        if (this.form.pass == '') {
           this.$message.error('手机号不能为空');
           return
        }
        if (!reg.test(this.form.pass)) {
              this.$message.error('请输入正确的手机号');
            return
        } else {

            that.$api.post("/upload/zcyzm",{'tel':this.form.pass}).then(res => {
                console.log(res);
                // +res.msg
                 if(res.code == 1){
                   this.$message({
                       message: '发送成功',
                       type: 'success',
                   });
                   this.time = 60;
                   this.disabled = true;
                   this.timer();
                 }else{
                   this.$message.error('发送失败');
                 }
                 this.$cookieStore.setCookie( 'yzms' ,res.msg, 61);
            })




        }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
          this.time--;
          this.btntxt = this.time + "s后重新获取";
          setTimeout(this.timer, 1000);
      }else{
          this.time = 0;
          this.btntxt = "获取验证码";
          this.disabled = false;
      }
    },
  },
 }
</script>



// WEBPACK FOOTER //
// src/components/MemberZh.vue